import { useEffect, useMemo } from 'react';
import { UserActionPriority } from '@/services/api/settingsApiArea/types';
import { useTranslation } from 'react-i18next';
import useEventsTrailSlice from '@/store/homeWidget/useEventsTrailSlice';

export const useFilterEvents = () => {
  const { t } = useTranslation();
  const {
    useFilters,
    useEvents,
    actions: { LoadEvents }
  } = useEventsTrailSlice();

  const [filter] = useFilters().useState();
  const [commonSettings] = useEvents().useState();

  useEffect(() => {
    LoadEvents();
  }, []);

  const filteredEvents: UserActionPriority[] = useMemo(() => {
    if (!commonSettings?.UserActionPriority) return [];

    return commonSettings.UserActionPriority.filter((event) => {
      const localizedText = event.TypeName;

      const matchesName = localizedText.toLowerCase().includes(filter.name.toLowerCase());

      const matchesModule =
        filter.module && filter.module !== '0'
          ? filter.module.toString() === event.ModuleName.toString()
          : true;

      return matchesName && matchesModule;
    });
  }, [commonSettings, filter.name, filter.module, t]);

  return {
    commonSettings,
    filteredEvents
  };
};
